import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'spassu-code-control-plane',
});

export const newActivityRouteRef = createSubRouteRef({
  id: 'spassu-code-control-plane/new',
  parent: rootRouteRef,
  path: '/new',
});

export const connectActivityRouteRef = createSubRouteRef({
  id: 'spassu-code-control-plane/connect',
  parent: rootRouteRef,
  path: '/activities/:activityId/connect',
});

export const activityCockpitRouteRef = createSubRouteRef({
  id: 'spassu-code-control-plane/cockpit',
  parent: rootRouteRef,
  path: '/activities/:activityId/cockpit',
});

export const activityCreationRouteRef = createExternalRouteRef({
  id: 'spassu-code-control-plane/activity-creation',
});

export const frontierRootRouteRef = createExternalRouteRef({
  id: 'spassu-code-control-plane/frontier-root',
});
